type ListingLabelInput = {
  title?: string | null;
  pitch?: string | null;
  location?: string | null;
  businessType?: { name?: string | null } | null;
  business?: {
    address?: { city?: string | null; state?: string | null } | null;
  } | null;
};

/** Broker-facing label. Use early listing details so drafts are distinguishable. */
export function listingLabel(
  listing: ListingLabelInput,
  fallback = "New business listing",
): string {
  const title = listing.title?.trim();
  if (title) return title;
  const pitch = listing.pitch?.trim();
  if (pitch) return pitch;

  const location =
    listing.location?.trim() ||
    [listing.business?.address?.city, listing.business?.address?.state]
      .map((part) => part?.trim())
      .filter(Boolean)
      .join(", ");
  const businessType = listing.businessType?.name?.trim();

  if (businessType && location) return `${businessType} in ${location}`;
  if (businessType) return businessType;
  if (location) return `Business in ${location}`;

  return fallback;
}

/** Identity shared with the public listing; private names remain a fallback. */
export function listingMarketplaceLabel(
  listing: ListingLabelInput,
  fallback = "New business listing",
): string {
  return listing.pitch?.trim() || listingLabel(listing, fallback);
}
